(function () {

    "use strict";

    angular
        .module('components')
        .component('hDateRangePicker', {
            bindings: {
                disablePeriods: '<',
                rangeFrom:'<',
                rangeTo:'<',
                minDate: '<',
                maxDate: '<',
                period:'<',
                isClearEnabled: '<',
                ngDisabled: '<',
                onRangeApplied: '&',
                startDayOfWeek: '<',
                buttonText: '<',
                timePeriods: '<'
            },
            controller: hDateRangePickerComponent,
            controllerAs: '$ctrl',
            templateUrl: '../hmodules/components/h-date-range-picker/h-date-range-picker.component.ng.html'
        });

    hDateRangePickerComponent.$inject = ['$scope'];

    function hDateRangePickerComponent($scope) {

        var self = this;

        var PERIODS = {
            TODAY: {
                key: "TODAY",
                label: $filter("translate")("Today")
            },
            THIS_MONTH: {
                key: "THIS_MONTH",
                label: $filter("translate")("This Month")
            },
            LAST_MONTH: {
                key: "LAST_MONTH",
                label: $filter("translate")("last Month")
            },
            THIS_WEEK: {
                key: "THIS_WEEK",
                label: $filter("translate")("This Week")
            },
            LAST_WEEK: {
                key: "LAST_WEEK",
                label: $filter("translate")("Last Week")
            },
            NEXT_WEEK: {
                key: "NEXT_WEEK",
                label: $filter("translate")("Next Week")
            },
            NEXT_MONTH: {
                key: "NEXT_MONTH",
                label: $filter("translate")("Next Month")
            },
            LAST_3_MONTH: {
                key: "LAST_3_MONTH",
                label: $filter("translate")("Last 3 Months")
            },
            LAST_6_MONTH: {
                key: "LAST_6_MONTH",
                label: $filter("translate")("Last 6 Months")
            },
            NEXT_3_MONTH: {
                key: "NEXT_3_MONTH",
                label: $filter("translate")("Next 3 Months")
            },
            NEXT_6_MONTH: {
                key: "NEXT_6_MONTH",
                label: $filter("translate")("Next 6 Months")
            },
            NEXT_12_MONTH: {
                key: "NEXT_12_MONTH",
                label: $filter("translate")("Next 12 Months")
            },
            LAST_12_MONTH: {
                key: "LAST_12_MONTH",
                label: $filter("translate")("Last 12 Months")
            }
        };


        var isValidRangeDate = function(date){
            return date && date  instanceof moment;
        };

        var isValidPeriod = function(){
            return self.period && PERIODS[self.period.toUpperCase()];
        };

        const generateDateRangeConfig = function() {
            const config = {};
            
            const rangePatterns = {
                day: {
                    current: [0],
                    past: [],
                    future: []
                },
                week: {
                    current: [0],
                    past: [-1],
                    future: [1]
                },
                month: {
                    current: [0],
                    past: [-1, -3, -6, -12],
                    future: [1, 3, 6, 12]
                }
            };

            Object.keys(rangePatterns).forEach(function(type) {
                const patterns = rangePatterns[type];
                
                patterns.current.forEach(function(offset) {
                    const key = generateRangeKey(type, 'current', Math.abs(offset) || 1);
                    config[key] = createRangeConfig(type, offset, Math.abs(offset) || 1);
                });
                
                patterns.past.forEach(function(offset) {
                    const count = Math.abs(offset);
                    const key = generateRangeKey(type, 'past', count);
                    config[key] = createRangeConfig(type, offset, count);
                });
                
                patterns.future.forEach(function(offset) {
                    const count = Math.abs(offset);
                    const key = generateRangeKey(type, 'future', count);
                    config[key] = createRangeConfig(type, offset, count);
                });
            });

            return config;
        };

        const generateRangeKey = function(type, direction, count) {
            const typeMap = {
                'day': count === 1 ? 'DAY' : count + '_DAY',
                'week': count === 1 ? 'WEEK' : count + '_WEEK', 
                'month': count === 1 ? 'MONTH' : count + '_MONTH'
            };
            
            const directionMap = {
                'current': 'THIS',
                'past': 'LAST',
                'future': 'NEXT'
            };
            
            if (direction === 'current' && type === 'day' && count === 1) {
                return 'TODAY';
            }
            
            return directionMap[direction] + '_' + typeMap[type];
        };

        const createRangeConfig = function(type, offset, count) {
            const config = { type: type };

            switch (type) {
                case 'day':
                    config.offset = offset;
                    config.duration = count - 1;
                    config.unit = 'day';
                    break;

                case 'week':
                    config.offset = offset;
                    config.duration = 6;
                    config.unit = 'day';
                    break;

                case 'month':
                    if (count === 1) {
                        config.offset = offset;
                        config.duration = 0;
                        config.unit = 'month';
                    } else {
                        if (offset < 0) {
                            config.offset = offset;
                            config.duration = count - 1;
                        } else {
                            config.offset = offset;
                            config.duration = count - 1;
                        }
                        config.unit = 'month';
                    }
                    break;
            }

            return config;
        };

        const DATE_RANGE_CONFIG = generateDateRangeConfig();

        const calculateDateRange = function(config) {
            let startDate, endDate;
            const now = moment();

            switch (config.type) {
                case 'day':
                    if (config.offset === 0) {
                        startDate = now.clone().locale("en").startOf('day');
                        endDate = now.clone().locale("en").endOf('day');
                    } else {
                        startDate = now.clone().add(config.offset, 'day').startOf('day');
                        endDate = startDate.clone().add(config.duration, config.unit).endOf('day');
                    }
                    break;

                case 'week':
                    const startDayOfWeekMoment = getWeekStart(now.clone().startOf('day'), self.startDayOfWeek || 'MON');
                    if (config.offset === 0) {
                        startDate = startDayOfWeekMoment.clone().startOf('day');
                    } else {
                        startDate = startDayOfWeekMoment.clone().add(config.offset, 'week').startOf('day');
                    }
                    endDate = startDate.clone().add(config.duration, config.unit).endOf('day');
                    break;

                case 'month':
                    if (config.offset === 0) {
                        startDate = now.clone().startOf('month');
                        endDate = now.clone().endOf('month');
                    } else if (config.offset === -1) {
                        const lastMonthDate = now.clone().subtract(1, "month");
                        startDate = moment([lastMonthDate.year(), lastMonthDate.month()]);
                        endDate = startDate.clone().endOf('month');
                    } else if (config.offset === 1) {
                        const nextMonthDate = now.clone().add(1, "month");
                        startDate = moment([nextMonthDate.year(), nextMonthDate.month()]);
                        endDate = startDate.clone().endOf('month');
                    } else if (config.offset < 0) {
                        startDate = now.clone().add(config.offset, 'month').startOf('month');
                        endDate = startDate.clone().add(config.duration, config.unit).endOf('month');
                    } else {
                        startDate = now.clone().add(1, 'month').startOf('month');
                        endDate = startDate.clone().add(config.duration, config.unit).endOf('month');
                    }
                    break;

                default:
                    startDate = now.clone().startOf('month');
                    endDate = now.clone().endOf('month');
                    break;
            }

            return { startDate, endDate };
        };

        const getSelectedDateRange = function (selectedDateRange) {
            const config = DATE_RANGE_CONFIG[selectedDateRange] || DATE_RANGE_CONFIG["THIS_MONTH"];
            let startDate = config.startDate.clone();
            let endDate = config.endDate.clone();

            if(isValidRangeDate(self.maxDate) && startDate.isAfter(self.maxDate)) {
                startDate = self.maxDate.clone();
            }

            if(isValidRangeDate(self.maxDate) && endDate.isAfter(self.maxDate)) {
                endDate = self.maxDate.clone();
            }

            if(isValidRangeDate(self.minDate) && startDate.isBefore(self.minDate)) {
                startDate = self.minDate.clone();
            }

            if(isValidRangeDate(self.minDate) && endDate.isBefore(self.minDate)) {
                endDate = self.minDate.clone();
            }

            return {
                from: startDate,
                to: endDate
            };
        };

        var unSelectDateRanges = function(){
            self.selectedDateRange = null;
            self.dateRanges.forEach(function (dr) {
                dr.selected = false;
            })
        };

        var setRangeDates = function(rangeFrom, rangeTo){
            self.dateRange.date_from = rangeFrom;
            self.dateRange.date_to = rangeTo;
            self.simpleCalendarOptions.render && self.simpleCalendarOptions.render();
        };

        self.dateRange = {};
        self.dateRanges = [
            PERIODS.TODAY,
            PERIODS.THIS_WEEK,
            PERIODS.LAST_WEEK,
            PERIODS.NEXT_WEEK,
            PERIODS.THIS_MONTH,
            PERIODS.LAST_MONTH,
            PERIODS.NEXT_MONTH,
            PERIODS.LAST_3_MONTH,
            PERIODS.NEXT_3_MONTH,
            PERIODS.LAST_6_MONTH,
            PERIODS.NEXT_6_MONTH,
            PERIODS.LAST_12_MONTH,
            PERIODS.NEXT_12_MONTH
        ];

        const generateFilteredRanges = function() {
            const allowedPeriods = self.timePeriods || ['PAST', 'CURRENT'];
            const allRanges = {
                PAST: [
                    PERIODS.LAST_WEEK,
                    PERIODS.LAST_MONTH,
                    PERIODS.LAST_3_MONTH,
                    PERIODS.LAST_6_MONTH,
                    PERIODS.LAST_12_MONTH
                ],
                CURRENT: [
                    PERIODS.TODAY,
                    PERIODS.THIS_WEEK,
                    PERIODS.THIS_MONTH
                ],
                FUTURE: [
                    PERIODS.NEXT_WEEK,
                    PERIODS.NEXT_MONTH,
                    PERIODS.NEXT_3_MONTH,
                    PERIODS.NEXT_6_MONTH,
                    PERIODS.NEXT_12_MONTH
                ]
            };

            let pastAndCurrentRanges = [];
            let futureRanges = [];

            const hasPast = allowedPeriods.includes('PAST');
            const hasCurrent = allowedPeriods.includes('CURRENT');
            const hasFuture = allowedPeriods.includes('FUTURE');

            if (hasPast && hasCurrent) {
                pastAndCurrentRanges = [
                    PERIODS.TODAY,
                    PERIODS.THIS_WEEK,
                    PERIODS.LAST_WEEK,
                    PERIODS.THIS_MONTH,
                    PERIODS.LAST_MONTH,
                    PERIODS.LAST_3_MONTH,
                    PERIODS.LAST_6_MONTH,
                    PERIODS.LAST_12_MONTH
                ];
            } else if (hasCurrent) {
                pastAndCurrentRanges = allRanges.CURRENT;
            } else if (hasPast) {
                pastAndCurrentRanges = allRanges.PAST;
            }

            if (hasFuture) {
                futureRanges = allRanges.FUTURE;
            }

            const ranges = [];

            const periodGroups = [
                {
                    current: PERIODS.TODAY,
                    past: null,
                    future: null
                },
                {
                    current: PERIODS.THIS_WEEK,
                    past: PERIODS.LAST_WEEK,
                    future: PERIODS.NEXT_WEEK
                },
                {
                    current: PERIODS.THIS_MONTH,
                    past: PERIODS.LAST_MONTH,
                    future: PERIODS.NEXT_MONTH
                },
                {
                    current: null,
                    past: PERIODS.LAST_3_MONTH,
                    future: PERIODS.NEXT_3_MONTH
                },
                {
                    current: null,
                    past: PERIODS.LAST_6_MONTH,
                    future: PERIODS.NEXT_6_MONTH
                },
                {
                    current: null,
                    past: PERIODS.LAST_12_MONTH,
                    future: PERIODS.NEXT_12_MONTH
                }
            ];

            periodGroups.forEach(group => {
                if (group.current && hasCurrent) {
                    ranges.push(group.current);
                }
                
                if (group.past && hasPast) {
                    ranges.push(group.past);
                }
                
                if (group.future && hasFuture) {
                    ranges.push(group.future);
                }
            });

            return { pastAndCurrentRanges, futureRanges, ranges };
        };

        const { ranges } = generateFilteredRanges();
        self.ranges = ranges;

        self.selectDateRange = function(dr){
            unSelectDateRanges();
            dr.selected = true;
            self.selectedDateRange = dr;
            var range = getSelectedDateRange(dr.key);
            setRangeDates(range.from, range.to);
        };

        self.applyRange = function () {
            self.onRangeApplied({
                range: self.selectedDateRange,
                from: self.dateRange.date_from,
                to: self.dateRange.date_to
            });
        };

        self.clearRange = function () {
            setRangeDates(null, null);
            unSelectDateRanges();
            if (self.rangeFrom && self.rangeTo) {
                self.onRangeApplied({
                    range: null,
                    from: null,
                    to: null
                });
            }
        };

        self.simpleCalendarOptions = {
            monthsPerView: 2,
            mode: 'RANGE'
        };

        self.onDateRangeChanged = function () {
            unSelectDateRanges();
        };

        self.initDatesAndPeriod = function(){
            if(isValidRangeDate(self.rangeTo) && isValidRangeDate(self.rangeFrom)){
                if(self.rangeFrom.isAfter(self.rangeTo, 'day')){
                    setRangeDates(null, null);
                    console.error('hDateRangePickerComponent: from date should same or before to date');
                }else{
                    setRangeDates(self.rangeFrom, self.rangeTo);
                }
            }else if(isValidPeriod()){
                self.selectDateRange(PERIODS[self.period.toUpperCase()]);

            }
        };

        const prepareDateRangesMap = (dateRanges) => {
            const dateRangesMap = {};

            for (let range of dateRanges) {
                const selectedDateRange = getSelectedDateRange(range.key);
                dateRangesMap[range.key] = {
                    from: selectedDateRange.from.format('YYYY-MM-DD'),
                    to: selectedDateRange.to.format('YYYY-MM-DD')
                };
            }

            return dateRangesMap;
        };

        const setActiveRangePeriod = (dateRangesMap, rangeFrom, rangeTo) => {
            if (!rangeFrom || !rangeTo) {
                return;
            }
            const rangeFromDate = rangeFrom.format('YYYY-MM-DD');
            const rangeToDate = rangeTo.format('YYYY-MM-DD');

            for (let i in dateRangesMap) {
                const range = dateRangesMap[i];

                if (range.from === rangeFromDate && range.to === rangeToDate) {
                    const dateRangeIndex = self.dateRanges.findIndex((dateRange) => dateRange.key === i);
                    self.selectDateRange(self.dateRanges[dateRangeIndex]);
                    return;
                }
            }
        };

        self.$onInit = () => {
            self.initDatesAndPeriod();
            self.updateRanges();
            const dateRangesMap = prepareDateRangesMap(self.dateRanges);
            setActiveRangePeriod(dateRangesMap, self.rangeFrom, self.rangeTo);
        };

        self.updateRanges = function() {
            const { ranges } = generateFilteredRanges();
            self.ranges = ranges;

            Object.keys(DATE_RANGE_CONFIG).forEach(key => {
                const config = DATE_RANGE_CONFIG[key];
                const { startDate, endDate } = calculateDateRange(config);
                DATE_RANGE_CONFIG[key].startDate = startDate;
                DATE_RANGE_CONFIG[key].endDate = endDate;
            });
        };

        self.$onChanges = function(changesObj){

            if (changesObj.minDate &&
                changesObj.minDate.currentValue !== changesObj.minDate.previousValue) {
                self.simpleCalendarOptions.min = self.minDate;
            }
            if (changesObj.maxDate &&
                changesObj.maxDate.currentValue !== changesObj.maxDate.previousValue) {
                self.simpleCalendarOptions.max = self.maxDate;
            }
            if (changesObj.timePeriods &&
                !changesObj.timePeriods.isFirstChange() &&
                changesObj.timePeriods.currentValue !== changesObj.timePeriods.previousValue) {
                self.updateRanges();
            }
            if(changesObj.period || changesObj.rangeFrom || changesObj.rangeTo){
                if(isValidRangeDate(self.rangeTo) && isValidRangeDate(self.rangeFrom) && self.rangeFrom.isAfter(self.rangeTo, 'day')){
                    setRangeDates(null, null);
                    console.error('hDateRangePickerComponent: from date should same or before to date');
                }else{
                    setRangeDates(self.rangeFrom, self.rangeTo);
                }
            }
        };
    }

})();
